<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ 'button.import-voip-call' | translate}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">

  </button>
</div>

<div class="modal-body">
  <!-- Güncelleme  -->
  <div>
    <form #createForm="ngForm" class="needs-validation" novalidate>
      <div class="card">
        <div class="card-body">

          <!-- Santral Dahili -->
          <div class="form-group">
            <label class="custom-form-label" for="voipId">{{'voip.name' | translate}}</label>
            <select name="voipId" [(ngModel)]="request.voipInternalId" class="form-control" required>

              <option [ngValue]="0"> {{'dropdown.no-preference' | translate}} </option>
              <option *ngFor="let option of voipInternals" [ngValue]="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>


          <!-- Başlangıç tarihi-->
          <div class="col">
            <label class="custom-form-label" for="startDate">{{'common.startDate' | translate}}</label>
            <p-calendar #startDate="ngModel" name="startDate" [(ngModel)]="request.startDate" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
              [dateFormat]="dateFormatEnum.DATE_TIME_PICKER_INPUT_FORMAT" [firstDayOfWeek]="'firstDayOfWeek'| translate" required>
            </p-calendar>
            <app-field-error-display [displayError]="startDate.invalid && startDate.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
            </app-field-error-display>
          </div>

          <!-- Bitiş tarihi-->
          <div class="col">
            <label class="custom-form-label" for="endDate">{{'common.endDate' | translate}}</label>
            <p-calendar #endDate="ngModel" name="endDate" [(ngModel)]="request.endDate" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
              [dateFormat]="dateFormatEnum.DATE_TIME_PICKER_INPUT_FORMAT" [firstDayOfWeek]="'firstDayOfWeek'| translate">
            </p-calendar>
          </div>


          <!-- showEmptyDestination -->
          <div class="form-group form-check form-switch">
            <input #showEmptyDestinationInput="ngModel" type="checkbox" class="form-check-input" name="showEmptyDestinationInput" id="showEmptyDestinationInput"
              [(ngModel)]="request.showEmptyDestination" />
            <label class="form-check-label" for="showEmptyDestinationInput">{{'voip.showEmptyDestination' | translate}}</label>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>

  <button type="button" [disabled]="createForm.form.invalid" class="btn btn-primary" (click)="save()">
    {{'button.save' | translate}}
  </button>
</div>